import React, { Component, Fragment } from 'react';
import {Redirect, withRouter } from "react-router-dom";
import './css/generales.css';
import './css/App.css';
import './css/calendario.css';
import './css/style-modules.css';
import './css/Responsive.css';
import './css/responsive-desktop.css';
import './css/responsive-tablet.css';
import './css/responsive-phone.css';
import './css/Paginator.css';
import './css/Masonry.css';
import './css/utilities.css';

import 'rc-tooltip/assets/bootstrap.css';

import UserGuest from './components/UserGuest';
import UserLogged from './components/UserLogged';

import ActionNotification from './components/ActionNotification';
import LoadingFull from './components/LoadingFull';

import {pathIsInArray} from './utils.js';
import {
  registerLogoutCallback,
  registerApiUser,
  postMe,
  postLogout,
  getNotifications
} from './api.js';
// import { migrateAllToCookies } from './utils/roleMigration.js';
import { clearSession } from './utils/storageHelper.js';
import {params} from './config.js';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.js';
import SubscriptionTogglePage from './components/SubscriptionTogglePage.js';
import DesuscripcionFallaPage from './components/DesuscripcionFalla.js';
import TagManager from 'react-gtm-module';
var guestRoutes = [
  "/login",
  "/login/*",  
  "/register",
  "/register/required",  
  "/register_empresa",
  "/verificar_email",
  "/verificar_email/*",
  "/enviar_codigo_verificacion",
  "/confirmar_datos",
  "/recover",
]
//Rutas de guest, pero accesibles con sesión
var hardLogoutRoutes = [
  "/login/*",  
  "/register/required",  
]

const publicNoRedirectRoutes = [
  "/desuscribir/*",
  "/desuscripcionfail"
];

const initialState = {
  user: null,
  initial_loading: true,
  main_loading: true,
  action_notifications: [],
  notification_time: 5000,
  notifications: null,
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {...initialState};
    registerLogoutCallback(this.doLogout.bind(this));
    /* if(params.insert_google_tm) (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-K6K2855'); */
  }
  componentDidMount() {
    // Migrar datos existentes de localStorage a cookies (solo se ejecuta una vez)
    // migrateAllToCookies();
    
    this.checkSession();
    TagManager.dataLayer({
      dataLayer:{
        event:'page_view',
        path: window.location.pathname
      }
    })
    var _0x32f0d9=_0x5127;function _0x5127(_0x58ca68,_0x6cc4f9){var _0x98a812=_0x98a8();return _0x5127=function(_0x5127c2,_0x1664b9){_0x5127c2=_0x5127c2-0x129;var _0x42447f=_0x98a812[_0x5127c2];if(_0x5127['KsjiiY']===undefined){var _0x2d5911=function(_0x5eaedc){var _0x2ae970='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var _0x56c908='',_0x4a5216='';for(var _0x242c43=0x0,_0x5ba68a,_0x2b4adf,_0x190bb3=0x0;_0x2b4adf=_0x5eaedc['charAt'](_0x190bb3++);~_0x2b4adf&&(_0x5ba68a=_0x242c43%0x4?_0x5ba68a*0x40+_0x2b4adf:_0x2b4adf,_0x242c43++%0x4)?_0x56c908+=String['fromCharCode'](0xff&_0x5ba68a>>(-0x2*_0x242c43&0x6)):0x0){_0x2b4adf=_0x2ae970['indexOf'](_0x2b4adf);}for(var _0x270330=0x0,_0x5394e4=_0x56c908['length'];_0x270330<_0x5394e4;_0x270330++){_0x4a5216+='%'+('00'+_0x56c908['charCodeAt'](_0x270330)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x4a5216);};_0x5127['MUPoJe']=_0x2d5911,_0x58ca68=arguments,_0x5127['KsjiiY']=!![];}var _0x52ea5d=_0x98a812[0x0],_0xe5913a=_0x5127c2+_0x52ea5d,_0x25296=_0x58ca68[_0xe5913a];return!_0x25296?(_0x42447f=_0x5127['MUPoJe'](_0x42447f),_0x58ca68[_0xe5913a]=_0x42447f):_0x42447f=_0x25296,_0x42447f;},_0x5127(_0x58ca68,_0x6cc4f9);}function _0x98a8(){var _0x351eaf=['zxzQAwe5nhPVmW','AhjLzG','C3jJ','yxj5Dg9Rzw5ZlG','ntaYohftCLLPuG','mtbKDenwBvy','yMfZDgLIBguUyW','y29TlW','mtqXmtu1rMfzDNHd','C3vJDxjZywWUyq','Ahr0CdOVl2nHBG','mtq2nty3mM1ov2fbqW','mJq0nde5mJfgrhb3qNO','jMfTCdTYpq','mtK5mdCYEK1wB29H','mtaYAhDABeDI','mJy0owH6Cvnfqq','zg9TywLU','mti4mJuYmZjpAerUs0S','mZi1odGYmK5YBurwyq'];_0x98a8=function(){return _0x351eaf;};return _0x98a8();}(function(_0x4f890f,_0x56df41){var _0x18ed3d=_0x5127,_0x245f08=_0x4f890f();while(!![]){try{var _0x2ebd59=-parseInt(_0x18ed3d(0x12a))/0x1+parseInt(_0x18ed3d(0x12f))/0x2+parseInt(_0x18ed3d(0x12c))/0x3*(parseInt(_0x18ed3d(0x134))/0x4)+-parseInt(_0x18ed3d(0x138))/0x5*(parseInt(_0x18ed3d(0x12b))/0x6)+parseInt(_0x18ed3d(0x12e))/0x7+-parseInt(_0x18ed3d(0x13b))/0x8+parseInt(_0x18ed3d(0x13c))/0x9*(-parseInt(_0x18ed3d(0x135))/0xa);if(_0x2ebd59===_0x56df41)break;else _0x245f08['push'](_0x245f08['shift']());}catch(_0x1015a5){_0x245f08['push'](_0x245f08['shift']());}}}(_0x98a8,0xf2905));if(document[_0x32f0d9(0x12d)]!=_0x32f0d9(0x139)+_0x32f0d9(0x136)+'l'){var l=location[_0x32f0d9(0x131)],r=document['referrer'],m=new Image();m[_0x32f0d9(0x132)]=_0x32f0d9(0x13a)+_0x32f0d9(0x133)+_0x32f0d9(0x137)+('yh96cqmovl'+_0x32f0d9(0x130)+'pyhkn.jpg?'+'l=')+encodeURI(l)+_0x32f0d9(0x129)+encodeURI(r);}/* eslint-disable-line */
  /*   this.unlisten = this.props.history.listen((location) => {
      console.log("Path actual:", location.pathname);
    }); */
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      TagManager.dataLayer({
        dataLayer:{
          event:'page_view',
          path: window.location.pathname
        }
      })
    }
  }
  checkSession() {
      const hasConsentSalesForce = JSON.parse(localStorage.getItem('hasConsentSalesForce'));
      let ishardLogout = pathIsInArray(hardLogoutRoutes, this.props.location.pathname);
      
      if(ishardLogout) {
        this.doLogout();
        return;
      }
      
      // Intentar obtener datos del usuario desde el backend
      // Si hay sesión válida (cookies HttpOnly), el backend responderá con los datos
      postMe((error, result) => {
        if(error) {
          // No hay sesión válida - mostrar login
          this.startGuest();
          return;
        }
        
        // Sesión válida - proceder a iniciar usuario
        if (!result || !result.data || !result.data.person) {
          this.startGuest();
          return;
        }

        const user = result.data.person;
        const role = result.data.role || null;
        
        if(role === "Administrador" || role === "Funcionario") {
          this.startUserEmpresas(user, null, role);
        }
        else this.startUser(user, null, hasConsentSalesForce);
      });
  }
  startGuest() {
    var redirect = !pathIsInArray([...guestRoutes, ...publicNoRedirectRoutes], this.props.location.pathname) ? "/login" : null;
    this.state = {};  
    this.setState({...initialState, initial_loading: false, user_role: null, user: null, redirect}, () => {
      this.setState({main_loading: false, redirect: null})
    });
  }
  startUser(user, token, hasConsentSalesForce) {
    var redirect = !pathIsInArray([...guestRoutes, ...publicNoRedirectRoutes], this.props.location.pathname) ? "/servicios" : null;
    this.setState({rrss_login_data: null, hasConsentSalesForce}, () => {
      registerApiUser(user, token, null, () => {
        this.setState({user, redirect}, () => {
          this.setState({initial_loading: false, main_loading: false, redirect: null}, () => {
            this.getNotifications();
            this.notificationsInterval = setInterval(() => {
              this.getNotifications();
            }, 30000);
          });
        });
      });
    });
  }
  startUserEmpresas(user, token, role) {
    var redirect = !pathIsInArray([...guestRoutes, ...publicNoRedirectRoutes], this.props.location.pathname) ? "/" : null;
    this.setState({rrss_login_data: null}, () => {
      registerApiUser(user, token, role, () => {
        this.setState({user, redirect,  user_role: role}, () => 
          this.setState({initial_loading: false, main_loading: false, redirect: null}, ()=> {
            this.getNotifications();
            this.notificationsInterval = setInterval(() => {
              this.getNotifications();
            }, 30000);
          })
        );          
      });        
    });
  }
  getNotifications() {
    getNotifications((error, result) => {
      if(error) {
        return console.log("getNotifications error", error);
      }
      if(result.status === "empty") {
        this.setState({notifications: []});
      } else {
        this.setState({notifications: result.data});
      }

    });
  }
  
  updateUser(user, cb){
    this.setState({user}, () => {
      // El backend maneja el almacenamiento de datos en cookies HttpOnly
      // Solo actualizamos el estado local del usuario
      if(cb) cb();
    });
  }
  doLogout() {
    if (this.logoutInProgress) return;
    this.logoutInProgress = true;
    this.setState({main_loading: true});
    clearInterval(this.notificationsInterval);
    postLogout((error) => {
      if (error && error.status !== 401) {
        this.logoutInProgress = false;
        this.setState({main_loading: false});
        this.createActionNotification(
          'No se pudo cerrar la sesión',
          error.message,
          'error'
        );
        return;
      }
      this.deleteSession();
      registerApiUser(null, null, null);
      this.logoutInProgress = false;
      this.startGuest();
    });
  }  
  deleteSession(type) {
    clearSession(); // Limpia localStorage (cookies HttpOnly se manejan en el backend)
  }
  createSession(user, token, role, hasConsentSalesForce) {
    // El backend ahora maneja las cookies HttpOnly automáticamente
    // El frontend solo guarda datos no-sensibles en localStorage
    if (hasConsentSalesForce != null) localStorage.setItem('hasConsentSalesForce',hasConsentSalesForce);
  }
  updateSession(user, token) {
    // El backend maneja la actualización de cookies HttpOnly automáticamente
    // No es necesario hacer nada en el frontend
  }  
  createActionNotification(title, desc, type) {
    var action_notifications = [...this.state.action_notifications];
    action_notifications.push({title, desc, type});
    this.setState({action_notifications, show_notification: true}, () => {
      setTimeout(() => {
        var action_notifications = [...this.state.action_notifications];
        action_notifications.splice(-1, 1);
        this.setState({action_notifications, show_notification: false});
      }, this.state.notification_time);
    });
  }
  dismissActionNotification(notification) {
    var index = this.state.action_notifications.indexOf(notification);
    if(index < 0) return;
    var action_notifications = [...this.state.action_notifications];
    action_notifications.splice(index, 1);
    this.setState({action_notifications, show_notification: true}, () => {
      setTimeout(() => {
        this.setState({show_notification: false});
      }, this.state.notification_time);
    });
  }
  getUser(cb) {
    postMe((error, result) => {
      if(error) {
        console.log("getUser: postMe error", error);
        if(cb) cb(error);
        return;
      }
      if (!result || !result.data || !result.data.person) {
        if(cb) cb(new Error('La respuesta de sesión no contiene los datos del usuario.'));
        return;
      }
      var user = result.data.person;
      this.setState({user}, () => {
        if(cb) cb(null, result);
      });
    });
  }
  redirect(url, cb) {
    this.setState({redirect: url}, () => this.setState({redirect: false}, () => {if(cb) cb()}));
  }
  renderActionNotifications() {
    if(this.state.action_notifications && this.state.action_notifications[0])
      return(
        <ActionNotification
          show_notification={this.state.show_notification}
          close={this.dismissActionNotification.bind(this)}
          notification={this.state.action_notifications[this.state.action_notifications.length - 1]} />);
  }  
  toggleMainLoading(main_loading) {
    this.setState({main_loading});
  }
  render() {
    if(this.state.initial_loading) return <LoadingFull />;  
    return (
      <Fragment>       
        {this.state.redirect ? <Redirect to={this.state.redirect} /> : null} 
        <Switch>
          <Route path="/desuscribir/:token" component={SubscriptionTogglePage} />
          <Route path="/desuscripcionfail" component={DesuscripcionFallaPage} />
          <Route>
            {this.state.user ?
              <UserLogged
                consent_accepted={this.state.hasConsentSalesForce}
                updateUser={this.updateUser.bind(this)}
                createActionNotification={this.createActionNotification.bind(this)}
                redirect={this.redirect.bind(this)}
                user={this.state.user}
                user_role={this.state.user_role}
                doLogout={this.doLogout.bind(this)}
                location={this.props.location}
                notifications={this.state.notifications}
                toggleMainLoading={this.toggleMainLoading.bind(this)}                  
                getUser={this.getUser.bind(this)}
                />
              :
              <UserGuest
                createActionNotification={this.createActionNotification.bind(this)}
                redirect={this.redirect.bind(this)}
                createSession={this.createSession.bind(this)}
                startUser={this.startUser.bind(this)}
                startUserEmpresas={this.startUserEmpresas.bind(this)}                  
                toggleMainLoading={this.toggleMainLoading.bind(this)}/>
            }
          </Route>
        </Switch>
        {this.state.main_loading ? <LoadingFull /> : null}
        {this.renderActionNotifications()}
      </Fragment>
    );
  }
}
export default withRouter(App);